import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import './assets/scss/main.scss'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import PicIcon from '@/components/PicIcon';
import VueI18n from 'vue-i18n' 
import i18n from './i18n'
Vue.use(VueI18n);
import VueMatomo from 'vue-matomo' 
import matomoUrl from './matomo/env.js';


import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)



// import DatePicker from 'vue2-datepicker';
// import 'vue2-datepicker/index.css';
// import 'vue2-datepicker/locale/zh-cn';

// Vue.use(DatePicker, DatePicker)

//matomo設定
let urlMatomo;
matomoUrl.map( e => {
    // if( window.location.href.indexOf(e.envUrl) != -1){
    if(document.URL.indexOf(e.envUrl) != -1){
        urlMatomo = e;
    }// end: if
});
if(!urlMatomo){
    urlMatomo = matomoUrl[0];
}

console.log('setting matomo', urlMatomo);

Vue.use(VueMatomo,{
    host: urlMatomo.staUrl,
    siteId: urlMatomo.siteId,
    router: router,
    requireConsent: true, // 是否需要同意才能收取資料  no tracking request will be sent to Matomo and no cookies will be set.
    requireCookieConsent: false, // todo
    enableLinkTracking: true,
    trackInitialView: true,  // 是否追蹤初始頁面
    // trackerUrl: urlMatomo.staUrl+'matomo.php', //紀錄追蹤的位置
    // trackerScriptUrl: urlMatomo.staUrl+'matomo.js',
    trackerFileName: 'matomo',
    debug: false

});



//安全性套件


const option={
    whiteList: {
        a: [ 'href', 'name', 'target' ,'style','class'],
        // We don't currently allow img itself by default, but
        // these attributes would make sense if we did.
        div: ['style','class'],
        span: ['style','class'],
        img: [ 'src', 'srcset', 'alt', 'title', 'width', 'height', 'loading' ],
        h1:[],h2:[],h3:[],h4:[],h5:[],br:[],table:[],tbody:[],td:[],tfoot:[],th:[],tr:[],thead:[],hr:[],p:[],b:[],ol:[],ul:[],li:[],pre:[],article:[],aside:[],footer:[],header:[],sup:[],
        
    },
    stripIgnoreTag: true, // 去掉不在白名單的標籤   true：// 去掉不在白名單的標籤
    stripIgnoreTagBody: ['script', 'style'] // 去掉不在白名單的標籤和屬性
    // ['tag1', 'tag2']：只去掉指定的不在白名單的標籤

}


import VueXss from 'vue-xss'
Vue.use(VueXss, option)



//替換掉原本的下拉選單下拉icon
import OpenIndicator from '@/components/OpenIndicator' //原本的icon長相
import SelectIcon from '@/components/SelectIcon' //新的icon長相

vSelect.props.components.default = () => ({ OpenIndicator, SelectIcon });
Vue.component('v-select', vSelect)


Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
})


//iCon component register globally
Vue.component('iCon', PicIcon)
const requireAll = (requireContext) => requireContext.keys().map(requireContext);
const req = require.context('@/assets/pic/svg', false, /\.svg$/);
requireAll(req);





Vue.config.productionTip = false

import { queryUser } from "@/api/users.js";
import { mapMutations,mapGetters} from 'vuex';
import { initGlobalData } from '@/utils/globe';
import {mixinMatomo} from '@/utils/mixin';
import { uuid } from 'vue-uuid';

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    data() {
        return {
            frozen: false,
            onLine: navigator.onLine,
            showBackOnline: false,
            loginFail: false,
        };
    },
    mixins: [ initGlobalData,mixinMatomo],
    async created(){ 
        await this.queryApiDoc(this.getUserInfo);
        await this.$store.dispatch("common/getDropDownList");
        //進站就要取得的資料，並且存在store
    },
    async mounted() {
        window.addEventListener('online', this.updateOnlineStatus);  //斷網設定
        window.addEventListener('offline', this.updateOnlineStatus);
        
    },
    watch:{
        frozen:{
            handler: function(n){
                if (n) {
                    document.body.style.top = `-${window.pageYOffset}px`;
                    document.body.classList.add('fixed');
                }
                else {
                    const scrollY = document.body.style.top;
                    document.body.style.top = '';
                    document.body.classList.remove('fixed');
                    window.scrollTo(0, parseInt(scrollY || '0') * -1);
        
                }
            }
        },
        onLine(v) {
            if (v) {
                this.showBackOnline = true;
                setTimeout(() => {
                    this.showBackOnline = false;
                }, 1000);
            }
        },
        '$store.state.setting.logoutLink': function(v) {
            if(v){
                if(this.loginFail){
                    console.log('轉導 store logoutLink',v)
                    this.logoutLink('1')
                }
            }
        },
        loginFail:{
            handler: function(n){
                if(n){
                    if(this.$store.state.setting.logoutLink){
                        this.logoutLink('2')
                    }
                }
                
            }
        }
    },
    computed:{
        ...mapGetters({
            getNextLink: 'setting/getNextLink',
        }),
    },
    methods: {
        ...mapMutations({
            setUserInfo:'user/setUserInfo', 
            setUserFirst: 'user/setUserFirst',  
        }),
        updateOnlineStatus(e) {
            console.log('hello ,window connect',navigator.onLine)
            const {type} = e;
            this.onLine = type === 'online';
        },
        async getUserInfo() {
            try{
                const {data } = await queryUser();
                if(data){
                    this.setUserFirst(data.info.agree)
                    this.setUserInfo(data)
                    this.loginFail = false;

                    let matomoUserId = localStorage.getItem('cpp_identity_id')
                    console.log("matomoUserId",matomoUserId)
                    if(!matomoUserId){
                        matomoUserId = uuid.v4();
                        localStorage.setItem('cpp_identity_id',matomoUserId)
                    }

                    this.matomoSetUserId(matomoUserId);

                }
            } catch(error){
                let currentEnv = process.env.VUE_APP_ENV;
                console.log('currentEnv for user info',currentEnv)
                console.log('error code',error.response.status)
                if(error.response.status == 403 || error.response.status == 401){
                    console.log('401 or 403  error',error.response.status )
                    if (currentEnv != 'test' && currentEnv != 'mock' ) {
                        console.log('currentEnv = uat or staging or production',currentEnv)
                        this.loginFail = true;
                    } 
                }
                
            }
            
        },
        logoutLink(v){
            console.log('轉導',v)
            window.location.href = this.getNextLink; //安全性轉
        }

    }
}).$mount('#app')